import { useConnect } from 'redux-bundler-hook'

import { selectZonesForHarvest, urls as harvestUrls } from '~/src/Harvest/bundle'
import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT, getDateTime } from '~/src/Lib/Utils'
import { urls as roomUrls } from '~/src/Room/bundle'

const logger = createLogger('useDefaultAnnotationFormState')

export default props => {
  const {
    dialogRouteInfo,
    harvests,
    phases,
    queryAdvanced,
    room: storeRoom,
    rooms,
    routeInfo,
  } = useConnect(
    'selectDialogRouteInfo',
    'selectHarvests',
    'selectPhases',
    'selectQueryAdvanced',
    'selectRoom',
    'selectRooms',
    'selectRouteInfo',
  )

  const { params: dialogParams } = dialogRouteInfo ?? EMPTY_OBJECT
  const { params: pageParams, pattern } = routeInfo
  const inRoomDashboard = pattern.startsWith(roomUrls.view)
  const inHarvestPage = pattern.startsWith(harvestUrls.view)
  const date = getDateTime(props.date ?? dialogParams?.date ?? 'now')

  let roomEntity = props.room ?? storeRoom
  if (inRoomDashboard) {
    if (roomEntity?.id !== Number(pageParams.id)) {
      ({ [pageParams.id]: roomEntity } = rooms)
    }
  }
  let harvest = props.harvest
  if (inHarvestPage) {
    if (!harvest || harvest.id !== Number(pageParams.id)) {
      ({ [pageParams.id]: harvest } = harvests)
    }
    if (harvest) {
      const harvestPhases = harvest.phases.map(p => phases[p?.id ?? p])
      const phase = harvestPhases.find(({ startDate, endDate }) => {
        if (!startDate || !endDate) return false

        const startDT = getDateTime(startDate)
        const endDT = getDateTime(endDate)

        if (!startDT.isValid || !endDT.isValid) return false

        return startDT.until(endDT).contains(date)
      })
      if (phase) {
        ({ [phase.room]: roomEntity } = rooms)
      }
    }
  }

  let zones
  let zone
  if (inRoomDashboard && queryAdvanced?.zones && !Array.isArray(queryAdvanced.zones)) {
    zone = Number(queryAdvanced.zones)
  }
  if (!zone && roomEntity && !inHarvestPage) {
    zones = props.room?.zones && roomEntity?.zones
  }
  if (inHarvestPage && harvest) {
    zones = selectZonesForHarvest(harvest)
  }

  zone = zone ?? (zones && zones.length === 1 ? zones[0] : undefined)
  const room = roomEntity?.id

  return {
    date,
    room,
    zone,
  }
}
